export const addresses = {
  providerAddress: "0x9385bA0ac58A29720Ff1a746f1CE60C6c7FfFA93",
};
